import React from "react";
import DeliverAddress from "../user/userOrders/DeliverAddress";
import CustomModal from "../../reusable/CustomModal/CustomModal";
import CommonButton from "../../reusable/Button";
import { useDispatch, useSelector } from "react-redux";
import { getAddressByUserId } from "../../api/common";
import { useEffect } from "react";
import { useState } from "react";
import { getFromLocalStorage } from "../../helpers";

const AddressListModal = ({
  visible,
  header,
  setVisible,
  SubmitHandler,
  footer,
  btnname,
  addAddressHandler,
}) => {
  const dispatch = useDispatch();
  const token = getFromLocalStorage('token')

  const { allAddressList } = useSelector((state) => state.common);

 

  useEffect(() => {
    if(token) dispatch(getAddressByUserId());
  }, []);

  return (
    <>
      <CustomModal
        visible={visible}
        title={header}
        onClose={setVisible}
        // onClickSubmit={addAddressHandler}
        width={600}
        btnname={btnname}
        className="filter-modal"
        footer={footer}
      >
        <div>
          <div style={{ height: "500px", overflowY: "scroll" }}>
            {allAddressList?.data?.userAddress.map((item, key) => {
              return (
                <div key={key}>
                  <DeliverAddress item={item} />
                  <hr />
                </div>
              );
            })}
          </div>

          <div className="d-flex justify-content-end align-items-center py-2  ">
            <CommonButton
              type="submit"
              className="button outlined px-4 mx-3 rounded-1 my-2   "
              onClick={addAddressHandler}
              lable={"Add Address"}
            />
            {/* <CommonButton
              type="submit"
              className="button outlined px-4 rounded-1 my-2   "
              onClick={SubmitHandler}
              lable={"Save"}
            /> */}
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default AddressListModal;
